import React, {Component} from 'react';
import {connect} from 'react-redux';
import './css/NearbyFuneralHomes.styl';
import NearbyFuneralHome from './NearbyFuneralHome';
import appConfig from '../../../../../../appConfig/AppConfig';
import Header from '../../../../../shared/library/Header/Header';
import {breakPointChecker} from '../../../../../shared/utilities/breakPointChecker.js';

const config = appConfig();

export class NearbyFuneralHomes extends Component {
  static propTypes = {
    funeralHome: React.PropTypes.object,
    funeralHomes: React.PropTypes.array,
  };

  state = {
    largeMobile: false,
    smallMobile: false,
  };

  componentDidMount() {
    window.addEventListener('resize', this.checkBreakPoint);

    this.checkBreakPoint();
  }

  checkBreakPoint = () => {
    this.setState({
      largeMobile: breakPointChecker(500),
      smallMobile: breakPointChecker(300),
    });
  };

  renderNearbyFuneralHomes(funeralHomes) {
    if (funeralHomes) {
      return funeralHomes.map((funeralHome, i) => (
        <NearbyFuneralHome funeralHome={funeralHome} key={i} />
      ));
    }
    return null;
  }

  render() {
    const viewAllLink = `${config.vanityDomain}/funeral-homes/directory/${
      this.props.funeralHome.location.state.urlName
    }/${this.props.funeralHome.location.city.urlName}`;

    const title = () => {
      if (this.state.smallMobile) {
        return 'Nearby';
      } else if (this.state.largeMobile) {
        return 'Nearby Homes';
      }
      return 'Nearby Funeral Homes';
    };

    return (
      <div className="nearby-funeral-homes-container">
        <Header
          type="aside-header"
          className="nearby-funeral-homes-container__title"
          title={title()}
        >
          <a
            href={viewAllLink}
            className="nearby-funeral-homes-container__link"
          >
            View all
          </a>
        </Header>
        <div className="funeral-homes">
          {this.renderNearbyFuneralHomes(this.props.funeralHomes)}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  funeralHome: state.funeralHomeStore,
});

export default connect(mapStateToProps)(NearbyFuneralHomes);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/NearbyFuneralHomes/index.js